import { BehaviorSubject, of } from "rxjs";

export class PaginatedTable {
  protected readonly adminTableRowHeightPx: number = 56;
  private _currentPage = 1;
  private _pageSize = 10;
  private _total = 0;
  private _error = "";
  private _loading = false;
  private _errorData = { dataList: [], totalCount: 0, error: true };
  private _dataList = [];
  private _currentPage$ = new BehaviorSubject<number>(this._currentPage);
  private _pageSize$ = new BehaviorSubject<number>(this._pageSize);
  private _total$ = new BehaviorSubject<number>(this._total);
  private _error$ = new BehaviorSubject<string>(this._error);
  private _loading$ = new BehaviorSubject<boolean>(this._loading);
  private _dataList$ = new BehaviorSubject<any[]>(this._dataList);
  private _first = 0;
  private _first$ = new BehaviorSubject<number>(this._first);

  get first() {
    return this._first;
  }

  set first(value: number) {
    this._first = value;
    this._first$.next(this._first);
  }

  get first$() {
    return this._first$.asObservable();
  }

  get currentPage() {
    return this._currentPage;
  }

  set currentPage(value: number) {
    this._currentPage = value;
    this._currentPage$.next(this._currentPage);
  }

  get pageSize() {
    return this._pageSize;
  }

  set pageSize(value: number) {
    this._pageSize = value;
    this._pageSize$.next(this._pageSize);
  }

  get total() {
    return this._total;
  }

  set total(value: number) {
    this._total = value;
    this._total$.next(this._total);
  }

  get error() {
    return this._error;
  }

  set error(value: string) {
    this._error = value;
    this._error$.next(this._error);
  }

  get loading() {
    return this._loading;
  }

  set loading(value: boolean) {
    this._loading = value;
    this._loading$.next(this._loading);
  }

  get errorData() {
    return this._errorData;
  }

  get currentPage$() {
    return this._currentPage$.asObservable();
  }

  get pageSize$() {
    return this._pageSize$.asObservable();
  }

  get total$() {
    return this._total$.asObservable();
  }

  get error$() {
    return this._error$.asObservable();
  }

  get loading$() {
    return this._loading$.asObservable();
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.first = (page - 1) * this.pageSize;
  }

  onPageSizeChange(pageSize: number) {
    this.pageSize = pageSize;
    this.first = (this.currentPage - 1) * pageSize;
  }

  onRowsPerPageChange(pageSize: number) {
    this.pageSize = pageSize;
    this.currentPage = 1;
    this.first = 0;
  }

  onPageTotalChange(total: number) {
    this.total = total;
  }

  refreshDataList() {
    this._currentPage$.next(this._currentPage);
  }

  loadData(): void {
    this.refreshDataList();
  }

  handleCatchError = (err: any) => {
    this.error = err;

    return of(this.errorData);
  };

  updateDataListMetadata = (response) => {
    this.total = response?.totalCount ?? 0;
    this.first = (this.currentPage - 1) * this.pageSize;
  };

  getAdminTableScrollHeight(pageSize?: number): string {
    const normalizedPageSize = Number(pageSize);
    const rows =
      Number.isFinite(normalizedPageSize) && normalizedPageSize > 0
        ? normalizedPageSize
        : this.pageSize > 0
          ? this.pageSize
          : 10;

    return `${rows * this.adminTableRowHeightPx}px`;
  }
}
